import type React from 'react';

import { Helmet } from 'react-helmet-async';

import { MetaRobots } from './components/MetaRobots';
import { usePageMeta } from './hooks/usePageMeta';

export const PageMeta: React.FC = () => {
	const {
		data: { canonicalUrl, description, title },
	} = usePageMeta();

	return (
		<>
			<Helmet>
				<title>{title}</title>
				<meta data-rh="true" name="description" content={description}></meta>
				<link data-rh="true" rel="canonical" href={canonicalUrl}></link>
			</Helmet>
			<MetaRobots />
		</>
	);
};
